import {Component, Input, OnInit} from '@angular/core';
import {League} from "@model";

@Component({
  selector: 'app-league-feeds-tab',
  templateUrl: './league-feeds-tab.component.html',
  styleUrl: './league-feeds-tab.component.scss',
  standalone: false
})
export class LeagueFeedsTabComponent implements OnInit {
  @Input({required: true}) league?: League;

  ngOnInit(): void {

  }
}
